module.exports = __webpack_public_path__ + "img/password.07b4437f.svg";